var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.imageSet)?_c('spinner'):_c('div',[_c('h1',{staticClass:"align-center"},[_vm._v("Edit "+_vm._s(_vm.imageSet.title))]),_vm._v(" "),_c('edit-form',{attrs:{"save":_vm.update,"image-set":_vm.imageSet}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }